<template>
    <v-dialog :value="$store.getters['admin/manageEventDialog']" persistent width="40%">
        <v-card>
            <v-card-title>Manage Event</v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-col>
                        <v-text-field v-model.trim="event.name" :rules="requiredRules" label="Name" required />
                        <v-date-picker v-model="event.startDate" />
                        <v-date-picker v-model="event.endDate" />
                    </v-col>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="saveEvent">Save Event</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {EventsHttp} from "../../../http/events";
    import {EventBus} from "../../../EventBus";

    export default {
        name: "ManageEventDialog",
        data() {
            return {
                isLoading: false,
                event: {},
                requiredRules: [
                    v => !!v || 'This field is required'
                ],
                valid: true
            }
        },
        methods: {
            async saveEvent() {
                if (this.$refs.form.validate()) {
                    this.isLoading = true;
                    try {
                        await EventsHttp.createEvent(this.event);
                        EventBus.$emit('message', {message: 'Event Saved Successfully', type: 'success'});
                        this.closeDialog();
                    } catch (e) {
                        EventBus.$emit('message', {message: e, type: 'error'});
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            async closeDialog() {
                await this.$store.dispatch('admin/setEvents');
                await this.$store.dispatch('admin/setManageEventDialog', false);
            }
        }
    }
</script>

<style scoped>

</style>
